import { useCallback, useState } from 'react';
import { ModalPosition } from '@sdk/components/ui/modal/modal.types';
import useModalState, { ModalState } from '@sdk/components/ui/modal/useModalState';

const LINK_MODAL_HEIGHT = 56;

export type LinkModalState = {
  modalState: ModalState;
  url: string;
  setUrl: (url: string) => void;
  onLinkClick: (url: string) => void;
  linkModalPosition: ModalPosition;
  isOpenedFromToolbar: boolean;
};

export function useLinkModalState(): LinkModalState {
  const [linkModalPosition, setLinkModalPosition] = useState({ top: 100, left: 100 });
  const [isOpenedFromToolbar, setIsOpenedFromToolbar] = useState(false);
  const onModalOpen = useCallback(() => {
    setTimeout(() => {
      const selection = window.getSelection();
      const rect = selection.getRangeAt(0).getBoundingClientRect();

      const position = {
        left: rect.left,
        top: rect.top - LINK_MODAL_HEIGHT,
      };

      setLinkModalPosition(position);
    });
  }, []);

  const modalState = useModalState({ hideBackdrop: true, noBody: true, onModalOpen });
  const [url, setUrl] = useState('');

  const onLinkClick = useCallback(
    (url: string, fromToolbar = false) => {
      setIsOpenedFromToolbar(fromToolbar);
      setUrl(url);
      modalState.open();
    },
    [setUrl, modalState]
  );

  return { modalState, linkModalPosition, url, setUrl, onLinkClick, isOpenedFromToolbar };
}
